"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Text = require("../../components/Text/Text.util");
var _getPseudoStyles = _interopRequireDefault(require("../../utils/getPseudoStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var FlatButton = {
  styles: function styles(theme) {
    return {
      root: _objectSpread({
        justifyContent: "center",
        minWidth: theme.spacing.base * 16,
        padding: [0, theme.spacing.base * 1.5],
        gap: theme.spacing.base / 2,
        borderRadius: 28,
        textTransform: "capitalize",
        "--color": theme.colors.baseContrast060
      }, (0, _Text.setTextCssVars)({
        fontSize: theme.typography.fontSize + 2,
        fontWeight: 400,
        lineHeight: 1
      })),
      small: {
        "& > svg": {
          width: 18,
          height: 18,
          minHeight: 18,
          minWidth: 18
        }
      },
      medium: {
        "& > svg": {
          width: 18,
          height: 18,
          minHeight: 18,
          minWidth: 18
        }
      },
      large: {
        "& > svg": {
          width: 18,
          height: 18,
          minHeight: 18,
          minWidth: 18
        }
      },
      label: {
        margin: 0
      },
      primary: _objectSpread({}, (0, _getPseudoStyles.default)({
        hover: {
          background: "".concat(theme.colors.primary, "1a")
        }
      })),
      ghost: _objectSpread(_objectSpread({}, (0, _Text.setTextCssVars)({
        fontSize: theme.typography.fontSize + 1
      })), {}, {
        borderWidth: 1,
        borderColor: theme.colors.primary,
        border: "1px solid ".concat(theme.colors.primary),
        background: theme.colors.themeBase
      }, (0, _getPseudoStyles.default)({
        hover: {
          background: "".concat(theme.colors.primary, "1a"),
          border: "2px solid ".concat(theme.colors.primary),
          borderWidth: 1
        }
      })),
      long: _objectSpread({}, (0, _Text.setTextCssVars)({
        fontSize: theme.typography.fontSize
      })),
      veryLong: {
        padding: [0, theme.spacing.base * 1.5]
      }
    };
  }
};
var _default = exports.default = FlatButton;